import './weeklyDateRange.scss'
import { useState } from 'react'
import arrowLeft from '../../assets/icons/arrow-left.svg'
import arrowRight from '../../assets/icons/arrow-right.svg'
import dayjs from 'dayjs'
import { ErrorMessage } from 'formik'

const WeeklyDateRange = ({ values, setFieldValue, name }) => {
  const getCurrentWeekDates = (date) => {
    const startOfWeek = date.getDate() - date.getDay() + 1 // Start from Monday
    const dates = []
    for (let i = 0; i < 7; i++) {
      const currentDate = new Date(date.setDate(startOfWeek + i))
      dates.push({
        date: currentDate,
        weekMonth: currentDate.toLocaleString('default', { month: 'short' }),
        weekDate: currentDate.getDate(),
        weekday: currentDate.toLocaleDateString('default', { weekday: 'short' }).toUpperCase(),
      })
    }
    return dates
  }

  const [currentWeek, setCurrentWeek] = useState(getCurrentWeekDates(new Date()))
  const currentDate = new Date()

  const handleDateClick = (date) => {
    const startDate = dayjs(values.startDate).unix()
    const endDate = dayjs(values.endDate).unix()
    const formatedcurrentDate = dayjs(dayjs(currentDate).format('YYYY-MM-DD')).unix()
    const formateDate = dayjs(dayjs(date).format('YYYY-MM-DD')).unix()
    if (formatedcurrentDate > formateDate) {
      return
    }

    if (startDate > formateDate && endDate) {
      // setFormData({
      //   ...formData,
      //   startDate: dayjs(date).format('YYYY-MM-DD'),
      // })
      setFieldValue('startDate', dayjs(date).format('YYYY-MM-DD'))
      // setStartDate(date)
      return
    }

    if (startDate > formateDate && !values.endDate && values.startDate) {
      // setFormData({
      //   ...formData,
      //   endDate: formData.startDate,
      // })
      // setFormData({
      //   ...formData,
      //   startDate: dayjs(date).format('YYYY-MM-DD'),
      // })
      setFieldValue('endDate', values.startDate)
      setFieldValue('startDate', dayjs(date).format('YYYY-MM-DD'))
    }

    if (startDate === formateDate) {
      // setFormData({
      //   ...formData,
      //   startDate: null,
      //   endDate: null,
      // })
      setFieldValue('startDate', null)
      setFieldValue('endDate', null)
      return
    }
    if (endDate === formateDate) {
      // setFormData({
      //   ...formData,
      //   endDate: null,
      // })
      setFieldValue('endDate', null)
      return
    }
    if (!values.startDate) {
      // setFormData({
      //   ...formData,
      //   startDate: dayjs(date).format('YYYY-MM-DD'),
      // })
      setFieldValue('startDate', dayjs(date).format('YYYY-MM-DD'))
    } else if (!values.endDate) {
      if (
        dayjs(dayjs(date).format('YYYY-MM-DD')).unix() >= dayjs(dayjs(values.startDate).format('YYYY-MM-DD')).unix()
      ) {
        // setFormData({
        //   ...formData,
        //   endDate: dayjs(date).format('YYYY-MM-DD'),
        // })
        setFieldValue('endDate', dayjs(date).format('YYYY-MM-DD'))
      } else {
        // setFormData({
        //   ...formData,
        //   startDate: dayjs(date).format('YYYY-MM-DD'),
        // })
        setFieldValue('startDate', dayjs(date).format('YYYY-MM-DD'))
      }
    } else {
      // setEndDate(date)
      // setFormData({
      //   ...formData,
      //   endDate: dayjs(date).format('YYYY-MM-DD'),
      // })
      setFieldValue('endDate', dayjs(date).format('YYYY-MM-DD'))
    }
  }

  const isSelected = (date) => {
    if (values.startDate && values.endDate) {
      return dayjs(date).format('YYYY-MM-DD') >= values.startDate && dayjs(date).format('YYYY-MM-DD') <= values.endDate
    }
    return dayjs(date).format('YYYY-MM-DD') === values.startDate
  }

  const changeWeek = (direction) => {
    const currentMonday = new Date(currentWeek[0].date)
    const newMonday = new Date(currentMonday.setDate(currentMonday.getDate() + direction * 7))
    setCurrentWeek(getCurrentWeekDates(newMonday))
  }

  function formatDateToDDMMYYYY(date) {
    const day = String(date.getDate()).padStart(2, '0') // Ensure two digits
    const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
    const year = date.getFullYear()

    return `${day}/${month}/${year}`
  }

  const isCurrentWeek = currentWeek.some((day) => day.date.toDateString() === currentDate.toDateString())

  return (
    // <ClickAwayListener
    //   onClickAway={() => {
    //     setFormData({
    //       ...formData,
    //       weekly: false,
    //     })
    //   }}
    // >
    <div className='weekly-date-range-picker-wrapper flex flex-column'>
      <div className='weekly-date-range-picker'>
        <div className='weekly-date-display flex justify-between align-center'>
          <span className='weekly-current-date'>{formatDateToDDMMYYYY(currentDate)}</span>
          <div className='weekly-date-arrows flex justify-between'>
            {!isCurrentWeek && (
              <button type='button' onClick={() => changeWeek(-1)}>
                <img className='weekly-arrow' src={arrowLeft} />
              </button>
            )}
            <button type='button' onClick={() => changeWeek(1)}>
              <img className='weekly-arrow' src={arrowRight} />
            </button>
          </div>
        </div>
        <div className='weekly-calendar-controls flex justify-between align-center'>
          {currentWeek.map((d) => (
            <div
              key={d.date}
              className={`weekly-complete-date flex flex-column align-center ${dayjs(d.date).isBefore(currentDate, 'day') ? 'past-date' : ''}`}
              onClick={() => handleDateClick(d.date)}
            >
              <span className='weekly-month'>{d.weekMonth}</span>
              <span className={`weekly-date flex justify-center align-center ${isSelected(d.date) ? 'selected' : ''}`}>
                {d.weekDate}
              </span>
              <span className='weekly-weekday'>{d.weekday}</span>
            </div>
          ))}
        </div>
      </div>
      <ErrorMessage name={name} component='div' className='error-msg' />
    </div>
    // </ClickAwayListener>
  )
}

export default WeeklyDateRange
